/**
 * The next quarter with room for a new engagement. One value, shown beside
 * booking CTAs on the pricing and offer pages; update it here when the
 * calendar fills. Quarter labels read the same in English, Finnish and
 * Swedish.
 */
export const NEXT_AVAILABLE_START = "Q1 2027";
